/**
 * class {RequestSettings}
 * should be used to configure api queries
 */
export class RequestSettings {
    /**
     * constructor of class
     * please use factory instead
     * @see {this.factory)
     * @param responseType
     * @param apiUrlPart
     * @param baseUrl
     */
    constructor(responseType, apiUrlPart, baseUrl) {
        this._responseType = responseType;
        this._apiUrlPart = apiUrlPart;
        this._baseUrl = baseUrl;
    }
    /**
     * Factory method to create an instance of this class without
     * having to correctly fill the constructor.
     * !!! You should always use this instead of the constructor !!!
     * @param values
     * @returns {RequestSettings}
     */
    static factory(values) {
        const sanitizedValues = {};
        sanitizedValues.responseType = values.responseType !== undefined ? values.responseType : 'json';
        sanitizedValues.apiUrlPart = values.apiUrlPart || '';
        sanitizedValues.baseUrl = values.baseUrl || '';
        return new RequestSettings(sanitizedValues.responseType, sanitizedValues.apiUrlPart, sanitizedValues.baseUrl);
    }
    /**
     * gets the base url for the to be configured api request
     * @returns {string}
     */
    get baseUrl() {
        return this._baseUrl;
    }
    /**
     * sets the base url for the to be configured api request
     * @param value
     */
    set baseUrl(value) {
        this._baseUrl = value;
    }
    /**
     * gets the api method to be called
     * @returns {string}
     */
    get apiUrlPart() {
        return this._apiUrlPart;
    }
    /**
     * sets the api method to be called
     * @param value
     */
    set apiUrlPart(value) {
        this._apiUrlPart = value;
    }
    /**
     * gets the {'arraybuffer' | 'blob' | 'json' | 'text'} of the to be configured request
     * @returns {'arraybuffer' | 'blob' | 'json' | 'text'}
     */
    get responseType() {
        return this._responseType;
    }
    /**
     * sets the {ResponseContentType} of the to be configured request
     * @param value
     */
    set responseType(value) {
        this._responseType = value;
    }
}
//# sourceMappingURL=requestSettings.js.map